<template>
  <div v-if="hasHighlights">
    <el-row class="featured-card-row">
      <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 18, offset: 3 }"
        class="featured-card">
        <el-row class="featured-card-flex" type="flex">
          <el-col class="featured-card-image-wrap" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }">
            <img :src="featuredHighlightImage" class="featured-card-image">
          </el-col>
          <el-col class="featured-card-copy" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }">
            <p class="card-subhead">{{ featuredHighlight.regionalHighlightSubhead }}</p>
            <h2>{{ featuredHighlight.regionalHighlightHeadline }}</h2>
            <div class="card-blurb" v-html="featuredHighlight.regionalHighlightCopy">
            </div>
            <a v-if="featuredHighlightLinkEnabled" :href="featuredHighlight.regionalHighlightLink[0].linkUrl">
              <el-button class="button" type="primary">
                {{ featuredHighlight.regionalHighlightLink[0].linkText }}
              </el-button>
            </a>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row type="flex" class="cards-row">
      <el-col v-for="(regionalHighlight, index) in secondaryHighlights" :key="index" class="card-wrap"
        :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 12, offset: 0 }">
        <regional-highlight :regional-highlight="regionalHighlight">
        </regional-highlight>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import RegionalHighlight from '@/components/home/RegionalHighlight.vue';
import home from './'

export default {
  name: 'RegionalHighlights',
  methods: {
  },
  components: {
    RegionalHighlight,
  },
  computed: {
    ...mapGetters(home.store.namespace, [
      'homeRegionalHighlights'
    ]),
    hasHighlights() {
      return this.homeRegionalHighlights && this.homeRegionalHighlights.length > 0 && this.homeRegionalHighlights[0];
    },
    featuredHighlight() {
      return this.homeRegionalHighlights?.[0] || {};
    },
    featuredHighlightImage() {
      return this.featuredHighlight?.regionalHighlightImage?.[0]?.url || '';
    },
    secondaryHighlights() {
      return this.homeRegionalHighlights?.slice(1) || [];
    },
    featuredHighlightLinkEnabled() {
      return this.featuredHighlight?.regionalHighlightLink?.length > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';
@import 'element-theme-chalk/src/mixins/mixins.scss';

.card-subhead {
  font-size: 0.9375rem;
  text-transform: uppercase;
  line-height: 1.125rem;
  margin-bottom: 12px;
  font-weight: 700;
  color: $--color-grayscale-5;
}

:deep(.card-blurb) {
  font-size: 1rem;
  color: $--color-grayscale-5;

  p {
    font-size: 1rem;
    color: $--color-grayscale-5;
  }

  ul {
    list-style: none;
    padding-left: 0;

    li {
      padding-left: 2em;
      margin-bottom: 0.5em;
      display: block;
      position: relative;
    }

    li::before {
      content: '';
      position: absolute;
      left: 0;
      top: 6px;
      width: 20px;
      height: 20px;
      background-repeat: no-repeat;
      background-image: url('@/assets/images/check-blue.svg');
    }
  }

  // Is this the right font size?
  // ::v-deep .card-blurb {
  //   font-size: 0.875rem;

  //   p {
  //     font-size: 0.875rem;
  //   }
  // }
}

.cards-row {
  flex-wrap: wrap;
  margin-right: 25px;
  margin-left: 25px;
}

.card-wrap {
  margin-bottom: 25px;
}

.featured-card-flex {
  flex-wrap: wrap;
}

.featured-card {
  background-color: $--color-white;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
}

.featured-card-image {
  position: relative;
  top: -35px;
  width: 80%;
  margin-left: 10%;
}

.featured-card-row {
  margin-bottom: 80px;
}

.featured-card-copy {
  padding-top: 60px;
  padding-bottom: 60px;
  padding-right: 60px;
}



h2 {
  color: $--color-secondary;
}

a {
  text-transform: uppercase;
}

@include res(sm-and-down, $--breakpoints-spec) {
  h2 {
    font-size: 25px;
  }

  .featured-card-image {
    margin: 0;
  }

  .featured-card-image-wrap {
    text-align: center;
  }

  .featured-card-copy {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 25px;
  }

  .cards-row {
    margin: 0;
  }

  .featured-card-row {
    margin-bottom: 25px;
  }

  .card-subhead {
    font-size: 0.75rem;
  }
}

.button {
  padding: 20px 35px;
  font-size: 14px;
}
</style>

